import { Controller, useWatch } from "react-hook-form";
import CustomPasswordInput from "../../ui/CustomPasswordInput/CustomPasswordInput";
import CustomButton from "../../ui/CustomButton/CustomButton";
import AuthLayout from "../authLayout/AuthLayout";
import AuthCard from "../authCard/AuthCard";
import { resetPasswordValidators } from "../../../lib/validations/authValidations";

export default function PasswordPageWrapper({
  title,
  subtitle,
  control,
  onSubmit,
  isSubmitting,
  buttonLabel = "Submit",
  validationRules = null,
  isTokenExpired = false,
  onResendActivation,
}) {
  // Needed for cross-field confirmPassword validation
  const currentPassword = useWatch({ control, name: "password" });
  const hasFormErrors = Boolean(
    validationRules && !validationRules.every((rule) => rule.valid),
  );

  return (
    <AuthLayout>
      <AuthCard
        title={title}
        subtitle={
          <div className="text-black-50 text-xs sm:text-sm">{subtitle}</div>
        }
      >
        <form className="flex flex-col gap-4" onSubmit={onSubmit}>
          <Controller
            name="password"
            control={control}
            rules={{
              validate: (v) => resetPasswordValidators.password(v) ?? true,
            }}
            render={({ field, fieldState }) => (
              <CustomPasswordInput
                label="Password:"
                radius="md"
                disabled={isSubmitting || isTokenExpired}
                showStrengthMeter={false}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                error={fieldState.error?.message}
              />
            )}
          />

          <Controller
            name="confirmPassword"
            control={control}
            rules={{
              validate: (v) =>
                resetPasswordValidators.confirmPassword(currentPassword, v) ??
                true,
            }}
            render={({ field, fieldState }) => (
              <CustomPasswordInput
                label="Confirm Password:"
                radius="md"
                disabled={isSubmitting || isTokenExpired}
                showStrengthMeter={false}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                error={fieldState.error?.message}
              />
            )}
          />

          {validationRules && (
            <div className="mt-2 text-xs mb-5">
              <ul className="pl-5 space-y-1 list-none">
                {validationRules.map((rule, idx) => (
                  <li key={idx} className="relative pl-5">
                    <span
                      className={`absolute left-0 top-1/2 -translate-y-1/2 rounded-full w-2 h-2 ${rule.valid ? "bg-green-600" : "bg-red-600"}`}
                    ></span>
                    {rule.label}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {!isTokenExpired && (
            <CustomButton
              type="submit"
              radius="xl"
              size="sm"
              fullWidth
              disabled={isSubmitting || hasFormErrors}
              loading={isSubmitting}
            >
              {buttonLabel}
            </CustomButton>
          )}

          {isTokenExpired && onResendActivation && (
            <CustomButton
              type="button"
              radius="xl"
              size="sm"
              fullWidth
              onClick={onResendActivation}
            >
              Request Reactivation
            </CustomButton>
          )}
        </form>
      </AuthCard>
    </AuthLayout>
  );
}
